import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { browserHistory } from 'react-router';
import classnames from 'classnames';

import { changePassword } from '../../../../action/AccountActions';
import { passwordValidation } from '../../../helpers/helperAccount';
import CustomButton from '../../../CustomButton';
import { toastr } from 'react-redux-toastr';

const ChangePasswordForm = (props) => {
    const { toggleLoader } = props

    const [data, setData] = useState({
        password: '',
        password_confirm: '',
    })
    const [errMessage, setErrMessage] = useState({
        password: '',
        password_confirm: '',
    })
    const [modal, setModal] = useState({
        show: false,
        content: '',
        error: false,
    })
    const [toggle_password, setToggle_password] = useState(true)
    const [toggle_password_confirm, setToggle_password_confirm] = useState(true)

    const togglePassword = () => {
        setToggle_password(!toggle_password);
    }

    const togglePassword2 = () => {
        setToggle_password_confirm(!toggle_password_confirm);
    }

    const handleInputChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    }

	const closeModal = () => {
		if (!modal.error) {
			browserHistory.push('/login');
		} else {
            const modalClose = modal;
			modalClose.error = false;
			modalClose.show = false;
			setModal(modalClose);
		}
	}

    const openModal = () => {
        setModal((prevState) => ({ ...prevState, show: true }))
	}

    const checkForm = (data) => {
        let error = false;
        const updatedErrMessage = { ...errMessage };

        for(let i in data){
            if(data[i] == ''){
                error = true;
                updatedErrMessage[i] = 'Enter your password!';
            }
            else if(updatedErrMessage[i]){
                updatedErrMessage[i] = null;
            }
        }

        if (!updatedErrMessage.password) {
			const validation = passwordValidation(data.password)
			if (!validation.result) {
                error = true;
                updatedErrMessage.password = validation.error;
            }
			else if (data.password !== data.password_confirm) {
				error = true;
                updatedErrMessage.password = 'Passwords do not match';
            }
        }

        if (!updatedErrMessage.password_confirm) {
			if (data.password !== data.password_confirm) {
                error = true;
                updatedErrMessage.password_confirm = 'Passwords do not match';
            }
        }

        setErrMessage(updatedErrMessage);
        return error;
    }

    const sendForm = (e) => {
        e.preventDefault()

        const params = {
            token: props.data.location.query.token,
            password: data.password,
            password_confirm: data.password_confirm
        };
        const error = checkForm(params);
        if(!error){
            toggleLoader(true);

            changePassword(params)
                .then((res, err)=>{
                    toggleLoader(false);
                    // toastr.success('You have successfully changed your password.')
                    setModal((prevState) => ({ ...prevState, content: 'The password has been changed.' }) )
                    openModal()
                })
                .catch((error,p)=>{
                    toggleLoader(false);
                    if (error.response.data.response.error) {
                        toastr.error(error.response.data.response.error)
                        const updateModalOpen = modal;
                        updateModalOpen.error = true;
                        updateModalOpen.content = error.response.data.response.error;
                        setModal(updateModalOpen);
    
                        openModal();
                    }
                });
        }
    }

    const { password, password_confirm } = errMessage;

    return(
        <div className="panel-body">
            <h3 className='login-header'>Change Password</h3>
            <div className="form-wrapper">

                <form onSubmit={sendForm}>
                    <div className={classnames('login-form form-group has-feedback', { 'has-error': password  })}>
                        <label className={`login-label ${(data.password.length) ? 'active' : ''}`}>New Password</label>
                        <input type={toggle_password ? "password" : "text"} name="password" className="vehicle-search" placeholder='New Password' onChange={handleInputChange}/>
                        <span className="fa fa-eye form-control-feedback" onClick={togglePassword}></span>
                        {password && <span className="help-block">{password}</span>}
                    </div>

                    <div className={classnames('login-form form-group has-feedback', { 'has-error': password_confirm })}>
                        <label className={`login-label ${(data.password_confirm.length) ? 'active' : ''}`}>Confirm Password</label>
                        <input type={toggle_password_confirm ? "password" : "text"} name="password_confirm" className="vehicle-search" placeholder='Confirm Password' onChange={handleInputChange}/>
                        <span className="fa fa-eye form-control-feedback" onClick={togglePassword2}></span>
                        {password_confirm && <span className="help-block">{password_confirm}</span>}
                    </div>

                    <div className="change-password-submit form-group submit-btn">
                        <CustomButton variant="primary" size="lg" value="Submit" type="submit" id="restore-button">Submit</CustomButton>
                    </div>
                </form>

            </div>
            <Modal size="small" show={modal.show} onHide={closeModal} dialogClassName={classnames('modal-custom', { 'has-error': modal.error })}>
					<Modal.Header>
						<Modal.Title>
							<div className={classnames({ 'has-error': modal.error })}>
								{modal.error ? 'Alarm!' : 'Success'}
							</div>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{modal.content}
					</Modal.Body>
					<Modal.Footer>
                        <CustomButton variant="primary" onClick={closeModal}>Close</CustomButton>
					</Modal.Footer>
				</Modal>
        </div>

    )
}

export default connect(
    null,
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	})
)(ChangePasswordForm)
